/* eslint-disable react-hooks/exhaustive-deps */
import { IState, IUser, useMainStore } from '@/settings/zustand'
import { useEffect, useState } from 'react'
import { Outlet, Route, Routes } from 'react-router'
import Loading from 'src/stories/Loading'
import initRouting from './initRouting'
import { useUser } from 'src/settings/zustand/user' 
 
let routeItems: any[] = []

const LayoutMain = (): JSX.Element => { 
    const [isLoading, setIsLoading] = useState( true ) 
    const user: IUser = useUser() 
    const lyt = useMainStore((state: IState) => state.layout ) 
    useEffect(() => {
        routeItems = initRouting(lyt, user)
        setIsLoading( false )    
    } , [ lyt, user ]) 
    
    // console.table( {routeItems} )
    return <div className=' layout-app-state overflow-y-auto ' id="pe-layout-main" role="article" data-testid="layout-main">
        {
            isLoading 
                ?
                <div className="layout-app-state flex-center"  id="loader"><Loading /></div>
                :
                <Routes>
                    <Route path="/" element={<><Outlet /></>} >
                        { routeItems } 
                    </Route>
                </Routes> 
        }
    </div>
}


export default LayoutMain
